/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Alternatives_View_ReviewInputs */

const en_directory_alternatives_view_review = /** @type {(inputs: Directory_Alternatives_View_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View full review`)
};

const zh_directory_alternatives_view_review = /** @type {(inputs: Directory_Alternatives_View_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看完整评测`)
};

/**
* | output |
* | --- |
* | "View full review" |
*
* @param {Directory_Alternatives_View_ReviewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_alternatives_view_review = /** @type {((inputs?: Directory_Alternatives_View_ReviewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Alternatives_View_ReviewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_alternatives_view_review(inputs)
	return zh_directory_alternatives_view_review(inputs)
});
export { directory_alternatives_view_review as "directory.alternatives.view_review" }